import React from 'react'
import { Box, Typography } from '@mui/material'
import TextField from 'components/Common/TextField'
import Grid from '@mui/material/Grid'
import Tooltip from 'components/Common/ToolTip/InfoTooltip'
import MaskField from 'components/Common/MaskField'

const IndividualSection = ({ onchange, data, errors }) => {
  const handleInput = e => {
    const { name, value } = e.target
    const individual = {
      individual: {
        ...data,
        [name]: value,
      },
    }
    onchange(individual)
  }
  return (
    <>
      <Typography variant="h6" className="my-5" style={{ color: '#25245F' }}>
        Individual Information
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField
            InputLabelProps={{ shrink: false }}
            className="customInput bootstrapLabel"
            label="Name"
            size="small"
            fullWidth
            bgwhite
            required
            error={false}
            onChange={handleInput}
            value={data.name}
            name="name"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <MaskField
            name='phone'
            isMasked
            maskPatten="000-000-0000"
            required
            fullWidth
            label="Work Phone Number"
            bgwhite
            zeroMarginLabel
            onChange={val => handleInput({
              target: {
                name: 'phone',
                value: (val.value).split('-').join('')
              }
            })}
            error={errors?.individual?.phone ? true : false}
            helperText={errors?.individual?.phone || ''}
          />
        </Grid>
        <Grid item xs={12} md={4} style={{ position: 'relative' }}>
          <TextField
            InputLabelProps={{ shrink: false }}
            className="customInput bootstrapLabel"
            label="Work Email"
            size="small"
            fullWidth
            disabled
            value={data.email}
          />
          <Box className="toolTipContainer">
            <Tooltip
              content={
                <Typography variant="body2" color="white">
                  You cannot change the email used to create your account at this time. If you would like to use a
                  different email, please fill out a support ticket using the “Help” button and we will work with you to
                  update it.
                </Typography>
              }
            />
          </Box>
        </Grid>
      </Grid>
    </>
  )
}

export default IndividualSection
